import React, { useMemo } from 'react'
import { Badge, RecordList } from '../BusinessDetailReport/BusinessDetailReport'
import styles from '../BusinessDetailReport/BusinessDetailReport.module.scss'
import { buildBusinessTies } from './businessTiesModel'

const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`

export default function BusinessTies({ person, showSummary = true }) {
    const model = useMemo(() => buildBusinessTies(person), [person])
    if (!model.hasData) return <div className={styles.calmLine}>No company roles, workplaces or assumed names found.</div>
    const { summary } = model
    return (
        <div className={styles.uccList}>
            {showSummary && summary.companies > 0 && (
                <div className={styles.inlineBadges}>
                    <Badge tone='neutral'>{plural(summary.companies, 'company', 'companies')}{summary.active ? ` · ${summary.active} active` : ''}</Badge>
                    {summary.bad > 0 && <Badge tone='declined' dot>{summary.bad} in bad standing</Badge>}
                </div>
            )}
            {model.roles.length > 0 && (
                <>
                    <div className={styles.uccGroupTitle}>Company roles</div>
                    <RecordList items={model.roles} />
                </>
            )}
            {model.workplaces.length > 0 && (
                <>
                    <div className={styles.uccGroupTitle}>{plural(model.workplaces.length, 'workplace')}</div>
                    <RecordList items={model.workplaces} />
                </>
            )}
            {model.assumedNames.length > 0 && (
                <>
                    <div className={styles.uccGroupTitle}>{plural(model.assumedNames.length, 'assumed business name')}</div>
                    <RecordList items={model.assumedNames} />
                </>
            )}
        </div>
    )
}
